<template>
    <vs-popup
          class="holamundo round-table-popup-settings-wrap"
          title="Round Tables - Advanced Settings"
          :active.sync="popupActive2"
        >
          <ul class="option-inner-wrap mb-5">
            <!--<li class="mb-4">
              <label for>Allow Attendees to Create Tables</label>
              <vs-switch v-model="settingsData.IsAttendeeCreateTableEnabled" />
            </li>-->
            <li class="mb-4">
              <label for>Enable Filter Option</label>
              <div class="popup-single-upload-right">
                <div class="info-option-wrapper">
                  <feather-icon class="" icon="InfoIcon" title="Info Icon"/>
                  <div class="popup-info-tooltips">
                    <img src="../../assets/images/show-filter-option.jpg" alt="Display"/>
                  </div>
                </div>
              <vs-switch v-model="settingsData.ShowFilter" />
              </div>
            </li>
            <li class="mb-4">
              <label for>Enable Search Option</label>
              <div class="popup-single-upload-right">
                <div class="info-option-wrapper">
                  <feather-icon class="" icon="InfoIcon" title="Info Icon"/>
                  <div class="popup-info-tooltips">
                    <img src="../../assets/images/search-option.jpg" alt="Display"/>
                  </div>
                </div>
              <vs-switch v-model="settingsData.ShowSearch" />
              </div>
            </li>
            <li class="mb-4">
              <label for>Enable Group Chat</label>
              <div class="popup-single-upload-right">
                <div class="info-option-wrapper">
                  <feather-icon class="" icon="InfoIcon" title="Info Icon"/>
                  <div class="popup-info-tooltips">
                    <img src="../../assets/images/show-group-chat.jpg" alt="Display"/>
                  </div>
                </div>
              <vs-switch v-model="settingsData.EnableGroupChat" />
              </div>
            </li>
            <li class="mb-4">
              <label for>Show Attendee List</label>
              <div class="popup-single-upload-right">
                <div class="info-option-wrapper">
                  <feather-icon class="" icon="InfoIcon" title="Info Icon"/>
                  <div class="popup-info-tooltips">
                    <img src="../../assets/images/show-attendees.jpg" alt="Display"/>
                  </div>
                </div>
              <vs-switch v-model="settingsData.ShowAttendeeList" />
              </div>
            </li>
            <li class="mb-4">
              <label for>Show Guest List</label>
              <div class="popup-single-upload-right">
                <div class="info-option-wrapper">
                  <feather-icon class="" icon="InfoIcon" title="Info Icon"/>
                  <div class="popup-info-tooltips">
                    <img src="../../assets/images/show-speaker-list.jpg" alt="Display"/>
                  </div>
                </div>
              <vs-switch v-model="settingsData.ShowSpeakerList" />
              </div>
            </li>
            <!--<li class="mb-4">
              <label for>Enable Raise Hand</label>
              <div class="popup-single-upload-right">
                <div class="info-option-wrapper">
                  <feather-icon class="" icon="InfoIcon" title="Info Icon"/>
                  <div class="popup-info-tooltips">
                    <img src="../../assets/images/enable-raise-hand.jpg" alt="Display"/>
                  </div>
                </div>
              <vs-switch v-model="settingsData.EnableRaiseHand" />
              </div>
            </li>-->
            <li class="mb-4">
              <label for>Allow Screen Share</label>
              <div class="popup-single-upload-right">
                <div class="info-option-wrapper">
                  <feather-icon class="" icon="InfoIcon" title="Info Icon"/>
                  <div class="popup-info-tooltips info-top-custom-tooltip">
                    <img src="../../assets/images/allow-screen-share.jpg" alt="Display"/>
                  </div>
                </div>
              <vs-switch v-model="settingsData.AllowScreenShare" />
              </div>
            </li>
            <li class="mb-4">
              <label for>Allow Recording</label>
              <div class="popup-single-upload-right">
                <div class="info-option-wrapper">
                  <feather-icon class="" icon="InfoIcon" title="Info Icon"/>
                  <div class="popup-info-tooltips info-top-custom-tooltip">
                    <img src="../../assets/images/allow-recording.jpg" alt="Display"/>
                  </div>
                </div>
              <vs-switch v-model="settingsData.AllowRecording" />
              </div>
            </li>
            <li class="mb-4">
              <label for>Auto Start Recording</label>
              <div class="popup-single-upload-right">
                <div class="info-option-wrapper">
                  <feather-icon class="" icon="InfoIcon" title="Info Icon"/>
                  <div class="popup-info-tooltips info-top-custom-tooltip">
                    <img src="../../assets/images/allow-recording.jpg" alt="Display"/>
                  </div>
                </div>
              <vs-switch v-model="settingsData.AutoStartRecording" />
              </div>
            </li>
            <li class="mb-4">
              <label for>Host Legend</label>
              <vs-input v-model="settingsData.HostLegend" />
            </li>
            <li class="mb-4">
              <label for>Text When Table is Full</label>
              <vs-input v-model="settingsData.TableFullText" />
            </li>
            <li class="mb-4">
              <label for>Text to Grab a Seat</label>
              <vs-input v-model="settingsData.SeatGrabText" />
            </li>
            <li class="mb-4">
              <label for>Text to Allow Audience to View</label>
              <vs-input v-model="settingsData.AllowAudienceViewText" />
            </li>
          </ul>
          <div align="right">
          <vs-button color="rgb(76, 139, 246)" type="filled" class="sub-btn" v-on:click="saveSettings"
            >Save</vs-button>
          </div>
        </vs-popup>
</template>
<script>
import moduleRoundtableManagement from "@/store/roundtable-management/moduleRoundtableManagement.js";
export default {
  components: {
  },
    props: {
    data: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      settingsData: { IsAttendeeCreateTableEnabled: false },
      popupActive2: this.data,
      IsDefaultSettings: false
    };
  },
  watch: {},
  computed: {
  },

  methods: {
    getDefaultSettings() {
      this.IsDefaultSettings = true;
      this.settingsData = {
        IsAttendeeCreateTableEnabled: false,
        ShowFilter: false,
        ShowSearch: false,
        EnableGroupChat:true,
        ShowAttendeeList:true,
        ShowSpeakerList:true,
        EnableRaiseHand:false,
        AllowScreenShare: false,
        AllowRecording:false,
        AutoStartRecording:false,
        HostLegend:"Host",
        TableFullText: "TABLE FULL",
        SeatGrabText: "GRAB A SEAT",
        AllowAudienceViewText: "SPECTATE",
      };
      this.popupActive2 = true;
    },
    getSettings() {
      this.$vs.loading();
      this.IsDefaultSettings = false;
      this.$store.dispatch("roundtableManagement/getSettings").then((res) => {
        this.settingsData = {
          DefaultSettingsLoaded: res.DefaultSettingsLoaded == undefined ? false : res.DefaultSettingsLoaded,
          IsAttendeeCreateTableEnabled: res.IsAttendeeCreateTableEnabled
            ? res.IsAttendeeCreateTableEnabled
            : false,
          ShowFilter: res.ShowFilter ? res.ShowFilter : false,
          ShowSearch: res.ShowSearch ? res.ShowSearch : false,
          EnableGroupChat:
            res.EnableGroupChat != undefined ? res.EnableGroupChat : true,
          ShowAttendeeList:
            res.ShowAttendeeList != undefined ? res.ShowAttendeeList : true,
          ShowSpeakerList:
            res.ShowSpeakerList != undefined ? res.ShowSpeakerList : true,
          EnableRaiseHand: res.EnableRaiseHand ? res.EnableRaiseHand : false,
          AllowScreenShare: res.AllowScreenShare != undefined ? res.AllowScreenShare : false,
          AllowRecording: res.AllowRecording ? res.AllowRecording : false,
          AutoStartRecording: res.AutoStartRecording ? res.AutoStartRecording : false,
          HostLegend: res.HostLegend ? res.HostLegend : "Host",
          TableFullText: res.TableFullText ? res.TableFullText : "TABLE FULL",
          SeatGrabText: res.SeatGrabText ? res.SeatGrabText : "GRAB A SEAT",
          AllowAudienceViewText: res.AllowAudienceViewText
            ? res.AllowAudienceViewText
            : "SPECTATE",
        };
        this.popupActive2 = true;
        this.$vs.loading.close();
      });
    },
    saveSettings() {
      this.$vs.loading();
      this.$store
        .dispatch("roundtableManagement/saveSettings", {
          settingsData: this.settingsData,
          IsDefaultSettings: this.IsDefaultSettings
        })
        .then((res) => {
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Settings",
            text: res.message,
          });
          this.IsDefaultSettings = false;
          this.popupActive2 = false;
          this.$emit('saveRoundtableSettingsData')
          this.$vs.loading.close();
        });
    },
  },
  mounted() {

  },
  created() {
    if (!moduleRoundtableManagement.isRegistered) {
      this.$store.registerModule(
        "roundtableManagement",
        moduleRoundtableManagement
      );
      moduleRoundtableManagement.isRegistered = true;
    }
    this.$store.dispatch("roundtableManagement/getSettings").then((res) => {
      this.settingsData = res;
      if(this.settingsData.ShowFilter == null){
        this.getDefaultSettings();
      }
    })
    
  },
};
</script>

